export const TRAINING_PROVIDER_SYSCODE = {
  SP: 1,
  RP: 2,
  NP: 3,
  TP: 4,
  NYP: 5,
  SIT: 6,
};

export const TrainingProviderSyscodeString = {
  [TRAINING_PROVIDER_SYSCODE.SP]: "Singapore Polytechnic",
  [TRAINING_PROVIDER_SYSCODE.RP]: "Republic Polytechnic",
  [TRAINING_PROVIDER_SYSCODE.NP]: "Ngee Ann Polytechnic",
  [TRAINING_PROVIDER_SYSCODE.TP]: "Temasek Polytechnic",
  [TRAINING_PROVIDER_SYSCODE.NYP]: "Nanyang Polytechnic",
  [TRAINING_PROVIDER_SYSCODE.SIT]: "Singapore Institute of Technology"
};